import { formatBalance } from "../utils/utils";
import icon_arrow from "../assets/icon-arrow.svg";
import icon_cet from "../assets/icon-cet.png";
import { Balance } from "../constants/constants";

type Props = {
  data: any;
  handleClick: (data: Balance) => void;
};

const ChooseTokenITem = ({ data, handleClick }: Props) => {
  return (
    <div
      onClick={() => {
        handleClick(data);
      }}
      className="flex gap-2 py-2 mt-4 whitespace-nowrap border-b-0 border-solid border-zinc-800"
    >
      <img
        loading="lazy"
        src={data.iconUrl ? data.iconUrl : icon_cet}
        className="shrink-0 w-12 h-12 rounded-full border border-[#252525] object-cover"
      />
      <div className="my-auto">{data.symbol}</div>
    </div>
  );
};

export default ChooseTokenITem;
